<template>
  <div class="mine-content">
    <p style="text-align:center;font-size:0.3rem;margin:0.2rem 0;font-weight:bold;">抽奖前，请给个反馈，帮助我们进步！</p>
    <FeedType v-for="(pep,index) in testPassages" :content="pep" :key="index" v-on:listenToChildEvent="getAnswer"></FeedType>
    <div class="btn-group">
      <button class="default-btn large-btn submit-btn" @click="submitDta" v-preventReClick>提交</button>
    </div>
  </div>
</template>

<script>
 import { mapState } from 'vuex'
 import FeedType from '../components/FeedType'
 import axios from 'axios';
 import qs from 'qs';
  export default {
    name: 'Feedback',
    components:{
      'FeedType':FeedType
    },
    props: {
      id: Number
    },
    data(){
      return {
        testPassages:[
          {'num':1,'order':'1.','title':'你对本次生涯周活动的整体评价是（1-10打分）','type':7,'show':true,'subTitle':[['很不满意','很满意'],['一点儿价值也没有','很有价值']],answer:[1,2],errorMessage:''},
          {'num':2,'order':'2.','title':'如果用三个词评价你参与的本次生涯周，你会用哪三个词？（多选）','type':4,'limit':3,'show':true,'options':['有趣','丰富','新颖','有用','启发','深入','枯燥','迷茫','烦躁','肤浅','冗长','难懂','其他'],errorMessage:''},
          {'num':3,'order':'3.','title':'本次生涯周，你印象最深刻的活动是','type':2,'show':true,'options':['1、疯狂动物城','2、生涯罗盘','3、大学生ToDoList','4、职业倾向测评','5、职业世界探索','6、职业倾向匹配','7、优秀大学生图鉴','8、职业能力知多少','9、目标职位能力大赏','10、决策风格测评','11、毕业政策探索','12、我的决策产生记','13、生涯扫雷'],errorMessage:''},
          {'num':4,'order':'4.','title':'本次生涯周，你最大的收获是：','type':6,'show':true,errorMessage:''},
          {'num':5,'order':'5.','title':'参加本次生涯周活动之前，以下每条描述与自己的符合程度是','type':1,'show':true,'subTitle':['生涯规划非常重要','主动规划我的未来','清晰的认识我自己','清晰的了解专业和职业','明确我的职业方向','知道大学要如何度过'],'answer':[1,2,3,4,5,6],titleArr: ['非常不符合', '2', '3', '4', '5', '6', '7', '8', '非常符合'],errorMessage:''},
          {'num':6,'order':'6.','title':'参加本次生涯周活动之后，以下每条描述与自己的符合程度是','type':1,'show':true,'subTitle':['生涯规划非常重要','主动规划我的未来','清晰的认识我自己','清晰的了解专业和职业','明确我的职业方向','知道大学要如何度过'],'answer':[1,2,3,4,5,6],titleArr: ['非常不符合', '2', '3', '4', '5', '6', '7', '8', '非常符合'],errorMessage:''},
          {'num':7,'order':'7.','title':'你是否会推荐其他同学来参与这个活动','type':2,'show':true,'options':['是','否','说不准'],errorMessage:''}
        ],
        currentAnswer:'',
        answers:[{'num':1,answer:[0,0]},{'num':5,answer:[0,0,0,0,0,0]},{'num':6,answer:[0,0,0,0,0,0]}],
        arrayAnswer:[],
        result:'',
        options:[],
      }
    },
    computed: {
      ...mapState({
        shengyaUser: state => state.shengyaUser.userInfo,
      }),
    },
    methods:{
      getAnswer(res,cur,type,s){
        let count =0;
        if(this.testPassages[cur-1].subTitle){
          count=this.testPassages[cur-1].subTitle.length
        }
        if(type==7||type==1){
          let chooseData ={id:s,res:res}
          this.currentAnswer=''
          this.answers.map((each,index)=>{
            if(each.num == cur){
              this.answers[index].answer[s-1] = chooseData
              this.answers[index].answer.map((item)=>{
                if(item.id){
                  this.currentAnswer += item.id+'<'+item.res
                  if(item.id<count){
                    this.currentAnswer +=','
                  }
                  this.testPassages[cur-1].errorMessage=''
                }else{
                  this.currentAnswer=''
                }
              })
            }
          })
        }else{
          // 题型为4的答案
           if(type==4){
             this.currentAnswer =''
             let no = this.options.indexOf(res)
             if(no>=0){
                 this.options.splice(no,1)
             }else{
               if(this.options.length<3){
                 this.options.push(res)
               }
             }
             if(this.options.length==3){
               this.testPassages[cur-1].errorMessage=''
               this.options.sort((a,b)=>{return a-b});
               this.currentAnswer = this.options.join('|')
             }else{
               this.currentAnswer =''
             }
           }else{
             // 题型为2、3、6的答案
             this.currentAnswer = res;
             this.testPassages[cur-1].errorMessage=''
           }
        }
        this.arrayAnswer.map((item,index)=>{
          if(item.id==cur){
             this.arrayAnswer.splice(index,1)
          }
        })
        if(this.currentAnswer){
          this.arrayAnswer.push({id:cur,res:this.currentAnswer})
        }
      },
      // 检查题目是否为空
      checkAnswer(){
        if(!this.contains(this.arrayAnswer)){
          this.arrayAnswer.push({id:4,res:''})
        }
        this.arrayAnswer.sort((a,b)=>{return a.id-b.id});
        let next=true
        if(this.arrayAnswer.length<7){
          next=false
        }
        if(!next){
          this.testPassages.map((item,index)=>{
            if(item.show){
              item.errorMessage='请回答此题'
            }
            this.arrayAnswer.map((answer,n)=>{
              if(item.num==answer.id||item.num==4){
                item.errorMessage=''
              }
            })
          })
          next=false
        }
        return next
      },
      // 添加每一页的答案到总的答案中
      addAnswerToResult(){
        this.result=""
        this.arrayAnswer.map((item,index)=>{
          this.result+=item.id+"$"+item.res;
          if(item.id<7){
            this.result+="}";
            this.currentAnswer='';
          }
        })
      },
      // 是否包含第4题答案
      contains(a) {
        let status = false
        a.map((item,index)=>{
          if(item.id == 4){
            status = true
          }
        })
        return status
      },
      // 数据提交
      submitDta(){
        if(this.checkAnswer()){
          this.addAnswerToResult()
          const options = {
            method: 'POST',
            headers: {'content-type': 'application/x-www-form-urlencoded'},
            data: qs.stringify({
              submitdata: this.result,
              openId: this.shengyaUser.openid
            }),
            url: '/cob/saveCosFeedback.do'
          };
          axios(options)
            .then((response)=>{
              if(response.data.result.success){
                let shengyaUser = response.data.data.user
                store.dispatch('setUserInfo', shengyaUser)
                // this.$bus.$emit('play-finish', shengyaUser)
                // this.$emit("listenToChildEvent")
              }
            })
            .catch((error)=>{
              console.log(error);
            });
        }
      }
    }
  }
</script>

<style>

</style>
